<template>
    <span
        class="mr-2"
        :class="{
            'chip-emerald': status == 1,
            'chip-rose': status == 0,
            'chip-amber': status != 0 && status != 1,
        }"
    >
        {{ statusName }}
    </span>
</template>

<script>
export default {
    props: ["status"],

    computed: {
        statusName() {
            switch (this.status) {
                case 1:
                case true:
                    return "Ativo";
                case 0:
                case false:
                    return "Inativo";
                default:
                    return this.status;
            }
        },
    },
};
</script>
